/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum ChargifySubDomain {
  'au-uat' = 'squiz-au-uat',
  au = 'squiz-au-production',
  uk = 'squiz-uk-production',
  us = 'squiz-us-production',
  nz = 'squiz-nz-production',
  sc = 'squiz-sc-production',
  pl = 'squiz-pl-production',
  'sxc-dev' = 'squiz-sxc-dev',
  'sxc-stg' = 'squiz-sxc-stg',
}
